import { FEATURES } from '@constants/Text'

/**
 * Visibilidade da Jornada do Cliente — o ÚNICO gate do módulo.
 *
 * O que a Jornada acrescenta passa por aqui: coluna Jornada e faixa de KPIs na
 * listagem, agrupamento por criticidade, cabeçalho com a barra de etapas no
 * perfil, card de próximo passo na sidebar e a rota `/resumo-cliente` (que
 * repete a flag em `meta.can_show`). Sem a feature, a plataforma fica
 * exatamente como era antes deste módulo existir — e é isso que os testes de
 * paridade em `controle-clientes.unit.js` e `client-profile.unit.js` travam.
 *
 * ATENCAO: `FEATURES.CLIENT_JOURNEY` ainda NÃO existe na lista de
 * `feature_access` que o backend devolve (ver `src/services/parameters.js`) —
 * ou seja, hoje a flag chega `undefined` em qualquer escritório e o módulo fica
 * invisível. Para validar antes do backend:
 * `localStorage.setItem('clientJourney', '1')` no console e recarregar.
 *
 * Mesmo desenho do `nav2026-enabled`: o override só LIGA — nunca desliga a
 * flag real quando ela existir.
 */
export const DEV_OVERRIDE_KEY = 'clientJourney'

/**
 * @param {Object} access store.getters['parameters/show']
 * @returns {boolean}
 */
export function isClientJourneyEnabled(access) {
  const show = access || {}
  if (show[FEATURES.CLIENT_JOURNEY]) return true
  try {
    return (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(DEV_OVERRIDE_KEY) === '1'
    )
  } catch {
    // localStorage indisponível (modo privado/bloqueado): módulo desligado.
    return false
  }
}
